export const formatDateTime = (dateString: string): string => {
  const targetDate = new Date(dateString);

  const timeFormat: Intl.DateTimeFormatOptions = {
    hour: '2-digit',
    minute: '2-digit',
    hour12: false,
  };

  const dateFormat: Intl.DateTimeFormatOptions = {
    day: '2-digit',
    month: '2-digit',
    year: 'numeric',
  };

  const time = targetDate.toLocaleTimeString('id-ID', timeFormat).replace(/\./g, ':');
  const date = targetDate.toLocaleDateString('id-ID', dateFormat);

  return `${date}, ${time}`;
};
